import { render } from "./MainQRAmThanh.vue?vue&type=template&id=7515b463&scoped=true"
import script from "./MainQRAmThanh.vue?vue&type=script&lang=js"
export * from "./MainQRAmThanh.vue?vue&type=script&lang=js"

import "./MainQRAmThanh.vue?vue&type=style&index=0&id=7515b463&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7515b463"]])

export default __exports__